import clsx from "clsx";
import { useState, useEffect } from "react";
import LoadingAnimation from "~/components/LoadingAnimation.jsx";
import { getValidMinPrice } from "~/util.js";

const ProductCard = ({ product, collectionHandle, pdp }) => {
  const productData = product;
  const validMinPrice = getValidMinPrice(productData);
  // console.log("Valid Minimum Price (excluding '48' variants):", validMinPrice);
  // console.log("product", product);

  const { images, priceRange, title, handle, media } = product;
  // console.log("priceRange", priceRange);
  const imageSrc =
    (images.edges.length > 0
      ? images.edges[0].node.src
      : media?.edges[0].node?.previewImage?.url) || "";

  const [showLoading, setShowLoading] = useState(true);
  const [showProductImage, setShowProductImage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoading(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowProductImage(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <a className="overflow-hidden rounded-md" href={`/products/${handle}`}>
      <div className="overflow-hidden relative rounded-md">
        {showLoading && <LoadingAnimation roastLevel={collectionHandle} pdp={pdp} />}
        <div className="relative w-full aspect-square flex items-center justify-center rounded-md">
          <img
            src={imageSrc}
            alt={title}
            className={clsx("w-full rounded-md", { invisible: !showProductImage })}
          />
        </div>
        <div className="mt-2 py-2">
          <span className="text-sm block font-semibold uppercase">{title}</span>
          {validMinPrice && priceRange.maxVariantPrice.amount !== validMinPrice ? (
            <span className="text-sm block">From ${validMinPrice.toFixed(2)}</span>
          ) : (
            <span className="text-sm block">
              ${validMinPrice ? validMinPrice.toFixed(2) : "N/A"} - $
              {Number(priceRange.maxVariantPrice.amount).toFixed(2)}
            </span>
          )}
        </div>
      </div>
    </a>
  );
};

export default ProductCard;
